import React from "react";

// Loading indicators: <Loader label="Loading orders" /> for a page, section or table, <Spinner /> inside a busy button
export default function Loader({ label }) {
  return (
    <div className="oz-loader" role="status" aria-live="polite">
      <span className="oz-loader-mark" aria-hidden="true">
        <span className="oz-loader-ring" />
        <span className="oz-loader-core">◈</span>
      </span>
      {label && <span className="oz-loader-label">{label}</span>}
    </div>
  );
}

export function Spinner() {
  return <span className="oz-spinner" aria-hidden="true" />;
}
